import React, { useEffect, useMemo, useState } from 'react';
import { BsInfoCircle, BsPlus, BsX } from 'react-icons/bs'

import styled from 'styled-components';
import _ from 'lodash';

import ReactQuill, { Quill } from "react-quill-v2.0";
import QuillBetterTable from 'quill-better-table';

import 'react-quill-v2.0/dist/quill.snow.css';
import 'react-quill-v2.0/dist/quill.bubble.css';
import "quill-better-table/dist/quill-better-table.css";


Quill.register({ "modules/better-table": QuillBetterTable });

const CloseButton = styled.button`
    width: 2rem;
    height: 2rem;
    border-radius: 2rem;
    background-color: red;
    position: absolute;
    top: -1rem;
    right: -1rem;
    color: white;
`;

function Editor({ value, onChange }) {
    const [isTableOptionsVisible, setTableOptionsVisible] = useState(false);
    const [tableConfig, setTableConfig] = useState({ rows: '', columns: '' });
    
    const reactQuillRef = React.useRef(null);
  
    const modules  = useMemo(() => {
        return {
            toolbar: {
                container: [
                    [{ font: [] }],
                    [{ header: [1, 2, 3] }],
                    [ "bold","italic", "underline","strike"],
                    ["blockquote"],
                    [{ list:  "ordered" }, { list:  "bullet" }],
                    [{ indent:  "-1" }, { indent:  "+1" }, { align: [] }],
                    ["link"],
                    ["clean"],
                    ["formula", "table"]
                ],
            },
            table: true,
            keyboard: {
                bindings: QuillBetterTable.keyboardBindings
            },
            'better-table': {
                operationMenu: {
                    items: {
                        unmergeCells: {
                            text: 'Another unmerge cells name'
                        }
                    },
                    color: {
                        colors: ['green', 'red', 'yellow', 'blue', 'white'],
                        text: 'Background Colors:'
                    }
                },
            },
        };
    }, []);

    const handleAddTable = () => {
        const editor = reactQuillRef.current.getEditor();
        const tableModule = editor.getModule("better-table");
        tableModule.showTableTools()
   
        
        tableModule.insertTable(+tableConfig.rows, +tableConfig.columns);
        setTableOptionsVisible(false);
    };

    useEffect(() => {
        if (reactQuillRef.current) {
            const editor = reactQuillRef.current.getEditor();
            const toolbar = editor.getModule("toolbar");

            toolbar.addHandler("table", () => setTableOptionsVisible(true));
        }
    }, []);

    return (
        <>
            {isTableOptionsVisible && (
                <div className="mt-2 mb-4 bg-light p-2 rounded position-relative border">
                    <CloseButton type='button' className='d-flex justify-content-center align-items-center' onClick={() => setTableOptionsVisible(false)}>
                        <BsX />
                    </CloseButton>
                   
                    <div className="d-flex justify-content-start align-items-center">
                        <select className='form-control input-sm' value={tableConfig.rows} onChange={(e) => setTableConfig((prev) => ({ ...prev, rows: e.target.value }))}>
                            <option value=''>Select row count</option>
                            {_.range(1, 10).map((row) => <option key={row} value={row}>{row}</option>)}
                        </select>
                        <select className='form-control input-sm mx-2' value={tableConfig.columns} onChange={(e) => setTableConfig((prev) => ({ ...prev, columns: e.target.value }))}>
                            <option value=''>Select column count</option>
                            {_.range(1, 10).map((column) => <option key={column} value={column}>{column}</option>)}
                        </select>
                        {tableConfig.rows && tableConfig.columns && (
                            <button type="button" onClick={handleAddTable} className='btn btn-success w-25 mr-2 text-center d-flex align-items-center justify-content-center'>
                                <BsPlus className='mr-2' />
                                <span>Insert</span>
                            </button>
                        )}
                    </div>

                    <div className='mt-2 p-2 bg-white rounded border text-uppercase text-center small text-dark d-flex justify-content-start align-items-center w-auto'>
                        <BsInfoCircle className='text-info'/>
                        <span className="ml-2">Right click on the table for more edit options</span>
                    </div>
                </div>
            )}

            <ReactQuill 
                ref={reactQuillRef} 
                value={value}
                className='app-comment' 
                modules={modules} 
                theme="snow" 
                onChange={onChange} 
            />
        </>
    );
}

export default Editor;